import axios from 'axios'
import { Upload } from 'tus-js-client'

export const register = data => {        
    return async dispatch => {
        await axios.post(`${process.env.REACT_APP_BE_BASE_URL}/api/v1/auth/registration`, data).then(response => {             
            dispatch({
                type: 'SUCCESS_REGISTER',
                registerData: response.data.data
            })

            return response.data
        }).catch(error => {                               
            dispatch({
                type: 'FAILED_REGISTER',
                notifyFailedRegister: true,
                failedRegisterMessage: error?.response?.data?.message
            })
        })
    }
}

export const resendOtp = data => {        
    return async dispatch => {
        await axios.post(`${process.env.REACT_APP_BE_BASE_URL}/api/v1/auth/registration/otp/resend`, data).then(response => {             
            dispatch({
                type: 'SUCCESS_REGISTER_OTP_RESEND',
                registerData: response.data.data
            })

            return response.data
        }).catch(error => {                           
            dispatch({
                type: 'FAILED_REGISTER_OTP_RESEND'               
            })
        })
    }
}

export const verifyOtp = data => {        
    return async dispatch => {
        await axios.post(`${process.env.REACT_APP_BE_BASE_URL}/api/v1/auth/registration/otp/verify`, data).then(response => {             
            dispatch({
                type: 'SUCCESS_REGISTER_OTP_VERIFY',
                userData: response.data.data
            })

            return response.data
        }).catch(error => {                           
            dispatch({
                type: 'FAILED_REGISTER_OTP_VERIFY'               
            })
        })
    }
}

export const forgotPassword = data => {        
    return async dispatch => {
        await axios.post(`${process.env.REACT_APP_BE_BASE_URL}/api/v1/auth/forgot-password`, data).then(response => {             
            dispatch({
                type: 'SUCCESS_FORGOT_PASSWORD'            
            })

            return response.data
        }).catch(error => {                               
            dispatch({
                type: 'FAILED_FORGOT_PASSWORD'                
            })
        })
    }
}

export const resetPassword = data => {        
    return async dispatch => {
        await axios.post(`${process.env.REACT_APP_BE_BASE_URL}/api/v1/auth/reset-password`, data).then(response => {             
            dispatch({
                type: 'SUCCESS_RESET_PASSWORD'            
            })

            return response.data
        }).catch(error => {                               
            dispatch({
                type: 'FAILED_RESET_PASSWORD'                
            })
        })
    }
}

export const updateProfile = ({ data }) => {        
    const accessToken = localStorage.getItem('accessToken')
    if (!accessToken || accessToken === 'null' || accessToken === 'undefined') {
      return async () => { throw new Error('Not logged in') }
    }
    const authToken = `Bearer ${accessToken}`    

    return async dispatch => {
        await axios.put(`${process.env.REACT_APP_BE_BASE_URL}/api/v1/accounts`, data, {                       
            headers: {
                Authorization: authToken,
                'ngrok-skip-browser-warning': 'true'
            }            
        }).then(response => {              
            dispatch({
                type: 'SUCCESS_UPDATE_PROFILE'            
            })         
        }).catch(error => {  
            dispatch({
                type: 'FAILED_UPDATE_PROFILE'            
            })                        
        })
    }
}

export const getProfile = () => {
    const accessToken = localStorage.getItem('accessToken')
    if (!accessToken || accessToken === 'null' || accessToken === 'undefined') {
      return async () => null
    }
    const authToken = `Bearer ${accessToken}`
  
    return async (dispatch) => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BE_BASE_URL}/api/v1/accounts`, {
          headers: {
            Authorization: authToken,
            'ngrok-skip-browser-warning': 'true'
          }
        })
  
        dispatch({
          type: 'SUCCESS_GET_PROFILE',
          account: response.data.data
        })
  
        return response.data.data
      } catch (error) {
        dispatch({ type: 'FAILED_GET_PROFILE' })
        throw error
      }
    }
}
  

export const updatePassword = ({ data }) => {
    const accessToken = localStorage.getItem('accessToken')
    const authToken = `Bearer ${accessToken}`
  
    return async (dispatch) => {
      try {
        const response = await axios.put(`${process.env.REACT_APP_BE_BASE_URL}/api/v1/auth/password`, data, {
          headers: { Authorization: authToken }
        })
  
        dispatch({
          type: 'SUCCESS_UPDATE_PASSWORD'       
        })
  
        return response.data.data   // ✅ return so .then() works
      } catch (error) {
        dispatch({ type: 'FAILED_UPDATE_PASSWORD' })
        throw error
      }
    }
}